<template>
  <div  class="affixDoc">
    <el-form :model="item" status-icon ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm">
      <el-form-item prop="pass">
          <span :alt="name" :title="name" class="label-wrap" slot="label">
            <span style="color:red;" v-if="isStar">*</span>
              {{ item.hideLable?'':( name ? ( name + '：') : '附件信息：' )}}
          </span>
          <p style="position:relative;width:100%">{{item.name}}</p>
          <label :style="{width:show?'120px':'80px'}" class="upload">
            <em  v-show="this.item.filePath" class="el-icon-view" @click="fileView(item)"></em>
            <em  v-show="this.item.filePath" class="el-icon-download" style="margin-left:10px" @click="fileDownload(item)"></em>
            <span v-show="IsShow(item)&&filingCBtn" class="qianzhang" @click="qianFn(item.filePath)">签章</span>
          </label>
      </el-form-item>
    </el-form>
      <el-dialog :visible.sync="imgDialogVisible" :modal="showModal" width="740px" height="100%" @closed="dialogClose">
          <img :src="filePath" alt="" @contextmenu.prevent=""  class="viewImg">
      </el-dialog>
      <el-dialog :visible.sync="pdfDialogVisible" @closed="dialogClose" height="100%" top="8vh" width="80%">
          <iframe  :src="pdfViewer + this.filePath + '?range=true' " @contextmenu.prevent="" frameborder="0" height="600" width="100%"></iframe>
      </el-dialog>
  </div>
</template>

<script>
    import $ from "jquery";
    export default {
    name: "index",
    data() {
      return {
          url:'',
          imgDialogVisible:false,
          pdfDialogVisible:false,
          pdfViewer:'/pdf/web/viewer.html?file=',
          dialogImageUrl:'',
          filePath:'',
          show:true,
      }
    },
    props: {
      index: {
        type: Number,
        required: false
      },
      labelWidth: {
          type: String,
         default:"150px"
      },
      item: {
        type: Object,
        required: true
      },
      showModal: {
          type: Boolean,
          default:true,
      },
      filingCBtn: {
          type: Boolean,
          default:true,
      },
      name: {
        type: String,
        required: false
      },
      entityId:{
        type: String,
        required: false
      },
      isStar:{
        type: Boolean,
        default:false,
        required: false
      }
    },
    methods:{

      fileView(item){

          // 获取文件类型
          // debugger;
          let type = item.name.substr(item.name.lastIndexOf(".")+1);
          let imgFlag = this.isAssetTypeAnImage(type);

          // let videoFlag = this.isAssetTypeAnVideo(type);
          // let audioFlag = this.isAssetTypeAnAudio(type);
          let pdfFlag = this.isAssetTypeAnPDF(type);

          if(pdfFlag){
              // this.imgDialogVisible = false;
              // this.pdfDialogVisible = true;
              // this.filePath = item.filePath;
              const pdfFilePath = this.pdfViewer + item.filePath + '?range=true';
              window.open(pdfFilePath);
              return
          }

          if(imgFlag){

              this.$httpReq({
                  method:'POST',
                  url:`/attachment/getAttachmentByCiteIdAndFileType?bizid=${item.bizId}&fileType=${item.fileType}`,
              }).then(res => {
                  if(res.data.code == '1'){
                      this.filePath = res.data.data.filePath;
                      this.imgDialogVisible = true;
                      this.pdfDialogVisible = false;
                  }
              })


          }else{

              this.fileDownload(item);

          }



      },
        dialogClose() {
            this.dialogImageUrl = "";
            this.imgDialogVisible = false;
        },

        isAssetTypeAnCompressed(ext){
            let arr = ['zip','Z', 'rar','sit','sys','tmp','gz','cab','7z'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnImage(ext){
            let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnVideo(ext) {
            let arr = ['mp4', 'rmvb', 'flv', 'mpeg', 'avi', 'mov', 'wmv', 'ram']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnAudio(ext) {
            let arr = ['mp3', 'wav', 'wma', 'ogg', 'ape', 'acc']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnPDF(ext) {
            let arr = ['pdf', 'PDF']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },

      fileDownload(item){
        if(item.filePath){
          this.$httpReq({
              method:'get',
              url:`/attachment/downloadFile?businessId=${item.bizId}&fileType=${item.fileType}`,
              // responseType:'blob'
          }).then(res => {
            // var typeName = item.name ? item.name.replace('.','') : '';
            // const blob = new Blob([res.data],{ type: 'application/'+typeName+',charset=utf-8' })
            // const url = window.URL.createObjectURL(blob)
            // const link = document.createElement('a')
            // link.href = url
            // link.download = item.name
            // link.click();
            // if (window.navigator.userAgent.indexOf('Trident') > -1) {
            //       // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
            //     navigator.msSaveBlob(blob, item.name) //ie10+
            // }
            //   let blob = new Blob([res.data])
            //   let fileName = this.item.name
            //   if('msSaveOrOpenBlob' in navigator){
            //       window.navigator.msSaveOrOpenBlob(blob, fileName);
            //   }else {
            //       let link = window.URL.createObjectURL(blob);
            //       let a = document.createElement('a');
            //       a.href = link;
            //       a.style.display = 'none';
            //       a.setAttribute('download', fileName);
            //       document.body.appendChild(a);
            //       a.click();
            //       // 移除元素
            //       document.body.removeChild(a);
            //       window.URL.revokeObjectURL(link);
            //       // this.url = window.URL.createObjectURL(blob);
            //   }

              if(res.data.code==='1'){
                  var a = document.createElement('a');
                  a.download = this.item.name;
                  a.target="_Blank";
                  a.href = res.data.data;
                  $("body").append(a);
                  a.click();
                  $(a).remove();

              }else{

                  this.$message({
                      type:'error',
                      message:res.data.msg
                  })

              }

          })
        }
      },
      qianFn(url){
        if(url.substring(url.length-4,url.length)!='.pdf'){
          this.$message.error('该文件不是pdf格式，不支持签章')
          return 
        }
        var that=this;
        window.open(process.env.VUE_APP_proxybaseurl + '/signature.html?url='+url+'&entityId='+this.entityId+'&fileType='+this.item.fileType)

        

      },
      IsShow(item){
        var mark = ''
        try {
          mark=item.remark?JSON.parse(item.remark):'';
        } catch(e){
          console.log(e)
          return false
        }
        if(mark && mark.signatureFlag && mark.signatureFlag==true){
          return true
        }
        return false
        
      }
    },
      created() {
        this.pdfViewer = process.env.VUE_APP_proxybaseurl + this.pdfViewer;
      },
      mounted() {
      const that = this;

      window.addEventListener("message",function(e) {
        if(e.data=='true'){
          that.$emit('refreshPdf',true)
        } 
      })
    }
  }
</script>

<style lang="scss" scoped>
  em{
    cursor: pointer;
  }
  p{
    margin: 0;
    padding: 0;
  }
  .upload{
    margin-left: 20px;
    width: 80px;
  }
  /deep/ .el-dialog__header{
    border-bottom: none;
  }
  /deep/ .el-dialog__body{
    text-align: center;
  }
  /deep/ .el-dialog__body img{
    width: 700px;
  }
  /deep/ .el-form-item__content{
    // margin-left: 214px!important;
  }
  .qianzhang{
    margin-left: 10px;
    color: #1890ff;
    cursor: pointer;
    &:hover{
      color: aqua;
    }
  }
</style>
